import { map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { uuid } from '../../core/helpers/uuid';
import { urlSafe } from '../../core/helpers/url-ready';
import { compareNumber } from '../../core/helpers/sorting';
var pagesUrl = '/pages';
var PagesService = /** @class */ (function () {
    function PagesService(http) {
        this.http = http;
    }
    PagesService.prototype.getPages = function (customerId) {
        var _this = this;
        var params = new HttpParams().set('customerId', customerId);
        return this.http.get(environment.baseApiUrl + pagesUrl, { params: params }).pipe(map(function (res) { return _this.preparePages(res.results); }));
    };
    PagesService.prototype.preparePages = function (pages) {
        var topLevel = uuid();
        var parentBased = pages.reduce(function (dict, page) {
            var _a;
            return Object.assign(dict, (_a = {},
                _a[page.parent || topLevel] = (dict[page.parent || topLevel] || []).concat([
                    page
                ]),
                _a));
        }, {});
        var lookup = {};
        var hierarchical = parentBased[topLevel]
            .map(this.getChildren.bind(this, '', parentBased, lookup))
            .sort(compareNumber(function (page) { return page.sortOrder; }));
        return hierarchical.map(this.toUXPage.bind(this, lookup));
    };
    PagesService.prototype.getChildren = function (prevUrl, parentBased, lookup, current) {
        var urlCode = urlSafe(current.directory);
        var url = prevUrl + "/" + urlCode;
        Object.assign(current, {
            url: url,
            children: (parentBased[current._id] || [])
                .map(this.getChildren.bind(this, url, parentBased, lookup))
                .sort(compareNumber(function (page) { return page.sortOrder; }))
        });
        return lookup[current._id] = current;
    };
    PagesService.prototype.toUXPage = function (lookup, page, index, pages) {
        var _this = this;
        return {
            id: page._id,
            code: page.code,
            type: page.type,
            menu: page.menu,
            name: page.name,
            introText: page.introText,
            slug: page.slug,
            directory: page.directory,
            parameters: page.parameters,
            settings: page.settings,
            banner: page.banner ? {
                img: page.banner.img,
                title: page.banner.title,
                subTitle: page.banner.subTitle,
                buttonText: page.banner.buttonText,
                link: this.prepareUrl(pages, page.banner.linkToPage),
            } : undefined,
            blocks: (page.blocks || []).map(function (block) { return ({
                img: block.img,
                title: block.title,
                subTitle: block.subTitle,
                buttonText: block.buttonText,
                link: _this.prepareUrl(pages, block.linkToPage),
                externalLink: block.linkToUrl
            }); }),
            children: page.children.map(this.toUXPage.bind(this, lookup)),
            videos: page.videos,
            facetgroups: page.facetgroups,
            blocksGroups: (page.blocksGroups || []).map(function (blocksGroup) { return ({
                code: blocksGroup.code,
                title: blocksGroup.title,
                blocks: (blocksGroup.blocks || []).map(function (block) { return ({
                    img: block.img,
                    title: block.title,
                    subTitle: block.subTitle,
                    buttonText: block.buttonText,
                    link: _this.prepareUrl(pages, block.linkToPage),
                    externalLink: block.linkToUrl
                }); })
            }); })
        };
    };
    PagesService.prototype.prepareUrl = function (pages, code) {
        if (Array.isArray(pages)) {
            var currentPage = pages.find(function (item) { return item.code === code; }) || null;
            return currentPage && currentPage.slug;
        }
        return '';
    };
    return PagesService;
}());
export { PagesService };
